// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const loudred: PokeData = {
  "id": 294,
  "name": "loudred",
  "height": 10,
  "weight": 405,
  "base_experience": 126,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "stomp",
    "bite",
    "roar",
    "supersonic",
    "screech",
    "rest",
    "sleep-talk",
    "uproar",
    "hyper-voice",
    "astonish",
    "howl",
    "synchronoise",
    "echoed-voice"
  ],
  "moves": [
    "bite",
    "supersonic",
    "hyper-voice",
    "quick-attack",
    "refresh",
    "purification",
    "body-slam",
    "scratch",
    "leer",
    "splash",
    "protect",
    "scary-face",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 145,
    "item": null,
    "species": [
      {
        "name": "whismur",
        "order": 319,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "loudred",
        "order": 320,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 293,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "exploud",
        "order": 321,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 294,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.5,
    "speed": 48,
    "ability_power": 71
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
